export const MOBILE = 720;
export const IPAD768 = 768;
export const IPAD810 = 810;
export const IPAD1024 = 1024;
export const DESKTOP1280 = 1280;
